import axios from 'axios'

const client = axios.create({
  baseURL: import.meta.env.VITE_APP_API_V1_BASE_URL as string,
  responseType: 'json',
  headers: {
    'Content-Type': 'application/json',
  },
})

export enum ImageType {
  FULL_IMAGE = 'full-image',
  AVATAR = 'avatar',
}

export class FileService {
  public static async uploadBase64Image(visitorId: string, type: ImageType, base64Image: string): Promise<string> {
    const response = await client.post('upload', {
      visitorId,
      type,
      data: base64Image,
    })

    return response.data as string
  }
}
